import { render, staticRenderFns } from "./ModalSearch.vue?vue&type=template&id=ac67097a&"
import script from "./ModalSearch.vue?vue&type=script&lang=js&"
export * from "./ModalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports